<template>
    <div class="h-20 border-b flex widget-card items-center justify-between w-full">
        <div class="flex items-center w-full main-container">
            <div>
                <el-checkbox
                    v-model="isChecked"
                    @change="onChange"
                />
            </div>
            <div class="widget-icon">
                <slot name="icon">
                    <component
                        class="text-primary iconTemplate"
                        :is="getTemplateIcon(widget.DataTypeID)"
                    />
                </slot>
            </div>
            <div class="widget-text">
                <div class="widget-title">
                    <slot name="title">
                        <div class="flex flex-col">
                            <div class="text-xl main-text-color break-normal">
                                {{ translateTemplateNameContentTag(widget) }}
                            </div>
                            <div class="text-sm main-text-color break-normal">
                                {{ widget.DashboardTitle }} ({{ widget.WidgetGroupTitle }})
                            </div>
                        </div>
                    </slot>
                </div>
                <div v-if="widget.Description"
                     class="widget-description">
                    <div class="text-sm text-gray-700">
                        {{ widget.Description }}
                    </div>
                </div>
            </div>
        </div>
        <div class="mr-6-5 preview">
            <slot name="template-preview"/>
        </div>
    </div>
</template>

<script>
import { Checkbox } from 'element-ui'
import { templateIcons } from '@/enum/widgetDataTypes'

export default {
    props: {
        widget: {
            type: Object,
            default: () => {
                return {}
            },
        }
    },
    components: {
        [Checkbox.name]: Checkbox
    },
    data() {
        return {
            isChecked: false,
            defaultIcon: 'IconWidgetDefault'
        }
    },
    watch: {
        'widget.isChecked' (newV) {
            this.isChecked = newV
        }
    },
    methods: {
        getTemplateIcon(templateDataTypeID) {
            return templateIcons[templateDataTypeID]
        },
        onChange (val) {
            this.widget.isChecked = val
            this.$emit('select-widget', this.widget.WidgetID)
        },
        translateTemplateNameContentTag(widget) {
            return this.$te(widget.TemplateNameContentTag) ? this.$t(widget.TemplateNameContentTag) : widget.WidgetTitle
        }
    }
}
</script>

<style lang="scss" scoped>
.widget-icon {
    width: 64px;
    height: 48px;
    display: grid;
    align-items: center;
    justify-content: center;
    margin-left: 35px;
}

.widget-text {
    @apply ml-6;
    align-self: flex-start;
}
.widget-description {
    @apply mt-1;
}

[dir="rtl"] .main-container {
    @apply pr-8;
}
[dir="ltr"] .main-container {
    @apply pl-8;
}

[dir="rtl"] .preview {
    @apply ml-6-5;
}
[dir="ltr"] .preview {
    @apply mr-6-5;
}

[dir="rtl"] .iconTemplate {
    @apply mr-9 ml-5;
}
[dir="ltr"] .iconTemplate {
    @apply ml-9 mr-5;
}
</style>
